import { ReservableUnitTypesEnum } from 'lane-shared/types/features/ReservableFeatureProperties';

type Params = {
  isHeadcountCapacityEnabled: boolean;
  useCustomTimeSlots?: boolean;
  unitType?: ReservableUnitTypesEnum;
};

export function shouldShowCustomTimeSlotsOverrideNotice({
  isHeadcountCapacityEnabled,
  useCustomTimeSlots,
  unitType,
}: Params): boolean {
  return Boolean(
    isHeadcountCapacityEnabled &&
      useCustomTimeSlots &&
      unitType === ReservableUnitTypesEnum.Minutes
  );
}
